import React from 'react';
import styles from './Advt.module.css';
import cn from 'classnames';
import { iconsSourcesCustom } from '../../helpers/icons';
import { formatPhoneNumber } from '../../helpers/titreHelper';

import { motion } from 'motion/react';

const Advt = React.memo(({ className, advtInfo }) => {
  let phoneNumberFormat = formatPhoneNumber(advtInfo?.number, ' ');
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className={cn(className)}
    >
      <div
        className={cn(styles.wrapper, {
          [styles.wrapper__hidden]:
            !advtInfo.label &&
            !phoneNumberFormat &&
            !advtInfo.socials &&
            !advtInfo.qrCode,
        })}
      >
        {/* {advtInfo.qrCode && (
          <div className={styles.left}>
            <img src={advtInfo.qrCode} alt="qr-code" />
          </div>
        )} */}
        {(advtInfo.label || phoneNumberFormat || advtInfo.socials) && (
          <div className={styles.right}>
            <div className={styles.desc}>
              {advtInfo.socials &&
                advtInfo.socials.map((item) => (
                  <div key={item} className={styles.icon}>
                    <img src={iconsSourcesCustom[item]} alt={item} />
                  </div>
                ))}
            </div>

            <div className={styles.number}>{phoneNumberFormat}</div>
            <div className={styles.title}>{advtInfo.label}</div>
          </div>
        )}
      </div>
    </motion.div>
  );
});

export default Advt;
